export enum TypographySize {
  xxs = 'xxs',
  xs = 'xs',
  s = 's',
  m = 'm',
  l = 'l'
}

export enum TypographyWeight {
  normal = 'normal',
  medium = 'medium',
  semiBold = 'semiBold',
  bold = 'bold'
}

export enum TypographyColor {
  primary = 'primary',
  secondary = 'secondary',
  error = 'error',
  main = 'main',
  fill = 'fill',
  shadow = 'shadow',
  background = 'background',
  accent = 'accent',
  black = 'black',
  white = 'white'
}

export enum TypographyTag {
  div = 'div',
  span = 'span',
  p = 'p',
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6'
}
